import { Box } from '@mantine/core';
import { DataTable } from 'mantine-datatable';
import SingleCustomerContext from '../Customer-Context/SingleCustomerContext';
import { useContext } from 'react';
import { TitleCell } from './TabelCells/TitleCell';
import { SwitchCell } from './TabelCells/SwitchCell';

interface Idea {
  _id: string;
  title: string;
  status: string;
  componentId: string;
  [key: string]: any;
}

interface ExpandedTableProps {
  ideas: Idea[];
  statusesColumns: any[];
  onRowClick: (record: Idea) => void;
}

export function ExpandedTable({ ideas, statusesColumns, onRowClick }: ExpandedTableProps) {


  const expandedColumns = [
    {
      accessor: 'title',
      noWrap: true,
      width: 251,
      render: (record: Idea) => <TitleCell record={record} />
    },
    ...statusesColumns.map((column: any, index: number) => ({
      ...column,
      accessor: column.accessor || `status_${index}`,
      width: 136.63,
      render: (record: Idea) => 
       
        <SwitchCell 
          key={`${record._id}-${column.accessor}`}
          record={record} 
          accessor={column.accessor} 
          statuses={column.statuses}/>
        
    }))
  ];

  return (
    <Box id="expanded-table">
      <DataTable
        key={`expanded-table-${ideas.length}`}
        mt={0}
        noHeader
        withColumnBorders
        columns={expandedColumns}
        records={ideas}
        onRowClick={onRowClick}
        highlightOnHover
        sx={{
          "tbody tr": {
            height: "48px",
            backgroundColor: "white",
            verticalAlign: "middle",
            textAlign: "center",
          },
          "td": {
            borderRight: "none",
            verticalAlign: "middle",
            padding: "8px 16px",
          }
        }}
      />
    </Box>
  );
} 